import { render, staticRenderFns } from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=template&id=309cd565&scoped=true"
import script from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=script&lang=ts"
export * from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=style&index=0&id=309cd565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309cd565",
  null
  
)

export default component.exports